import { render, staticRenderFns } from "./caseDetails.vue?vue&type=template&id=613e83e9&scoped=true"
import script from "./caseDetails.vue?vue&type=script&lang=js"
export * from "./caseDetails.vue?vue&type=script&lang=js"
import style0 from "./caseDetails.vue?vue&type=style&index=0&id=613e83e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613e83e9",
  null
  
)

export default component.exports